import { useContext } from 'react';

import { ProjectDataContext } from './ProjectDataContext';

export const useProjectData = () => {
    const context = useContext(ProjectDataContext);
    if (!context)
        throw new Error(
            'useProjectData must be used within ProjectDataProvider'
        );
    return context;
};
